import Admin from '@/components/admin/index/Index'
// import Cate from '@/components/admin/cate/Cate'
import CateCreate from '@/components/admin/cate/CateCreate'
import CateEdit from '@/components/admin/cate/CateEdit'
import Articel from '@/components/admin/articel/Articel'
import ArticelCreate from '@/components/admin/articel/ArticelCreate'
import ArticelEdit from '@/components/admin/articel/ArticelEdit'
import Team from '@/components/admin/team/Team'
import TeamCreate from '@/components/admin/team/TeamCreate'
import TeamEdit from '@/components/admin/team/TeamEdit'
import Menu from '@/components/admin/menu/Menu'
import MenuCreate from '@/components/admin/menu/MenuCreate'
import MenuEdit from '@/components/admin/menu/MenuEdit'
import AdminCreate from '@/components/admin/admin/AdminCreate'
import AdminEdit from '@/components/admin/admin/AdminEdit'
import Roles from '@/components/admin/roles/Roles'
import RolesCreate from '@/components/admin/roles/RolesCreate'
import RolesEdit from '@/components/admin/roles/RolesEdit'
import Permissions from '@/components/admin/permissions/Permissions'
import PermissionsCreate from '@/components/admin/permissions/PermissionsCreate'
import PermissionsEdit from '@/components/admin/permissions/PermissionsEdit'
import Ad from '@/components/admin/ad/Ad'
import AdCreate from '@/components/admin/ad/AdCreate'
import AdEdit from '@/components/admin/ad/AdEdit'
import UserDetail from '@/components/admin/user_detail/UserDetail'
import UserDetailCreate from '@/components/admin/user_detail/UserDetailCreate'
import UserDetailEdit from '@/components/admin/user_detail/UserDetailEdit'
import BannerCreate from '@/components/admin/banner/BannerCreate'
import BannerEdit from '@/components/admin/banner/BannerEdit'
import ArticlesCreate from '@/components/admin/articles/ArticlesCreate'
import ArticlesEdit from '@/components/admin/articles/ArticlesEdit'
import SettingCreate from '@/components/admin/setting/SettingCreate'
import SettingEdit from '@/components/admin/setting/SettingEdit'
import DyLogCreate from '@/components/admin/dy_log/DyLogCreate'
import DyLogEdit from '@/components/admin/dy_log/DyLogEdit'
import ZipJobCreate from '@/components/admin/zip_job/ZipJobCreate'
import ZipJobEdit from '@/components/admin/zip_job/ZipJobEdit'
import ZipClashCreate from '@/components/admin/zip_clash/ZipClashCreate'
import ZipClashEdit from '@/components/admin/zip_clash/ZipClashEdit'
import About from '@/components/admin/about/About'
//import hook
import Login from '@/components/admin/login/Login'

function getRouter() {

}

let routes = [
  {
    path: '/login',
    name: "Login",
    component: Login
  },
  {
    path: '/',
    name: 'Admin',
    component: Admin,
    default: 'Admin',

    children: [

      {
        path: '/cate/create',
        name: 'CateCreate',
        component: CateCreate,
      },

      {
        path: '/cate/edit',
        name: 'CateEdit',
        component: CateEdit,
        props: true
      },

      {
        path: '/articel',
        name: 'Articel',
        component: Articel,
      },
      {
        path: '/articel/create',
        name: 'ArticelCreate',
        component: ArticelCreate,
      },
      {
        path: '/articel/:id/edit',
        name: 'ArticelEdit',
        component: ArticelEdit,
        props: true
      },
      {
        path: '/team',
        name: 'Team',
        component: Team,
      },
      {
        path: '/team/create',
        name: 'TeamCreate',
        component: TeamCreate,
      },
      {
        path: '/team/:id/edit',
        name: 'TeamEdit',
        component: TeamEdit,
        props: true
      },
      {
        path: '/menu',
        name: 'Menu',
        component: Menu,
      },
      {
        path: '/menu/create',
        name: 'MenuCreate',
        component: MenuCreate,
      },
      {
        path: '/menu/:id/edit',
        name: 'MenuEdit',
        component: MenuEdit,
        props: true
      },
      {
        path: '/admin/create',
        name: 'AdminCreate',
        component: AdminCreate,
      },
      {
        path: '/admin/:id/edit',
        name: 'AdminEdit',
        component: AdminEdit,
        props: true
      },
      {
        path: '/roles',
        name: 'Roles',
        component: Roles,
      },
      {
        path: '/roles/create',
        name: 'RolesCreate',
        component: RolesCreate,
      },
      {
        path: '/roles/:id/edit',
        name: 'RolesEdit',
        component: RolesEdit,
        props: true
      },
      {
        path: '/permissions',
        name: 'Permissions',
        component: Permissions,
      },
      {
        path: '/permissions/create',
        name: 'PermissionsCreate',
        component: PermissionsCreate,
      },
      {
        path: '/permissions/:id/edit',
        name: 'PermissionsEdit',
        component: PermissionsEdit,
        props: true
      },

      {
        path: '/cate',
        name: 'Cate',
        component: () => {
          return import ('../components/admin/cate/Cate');
        },
      },
      {
        path: '/ad',
        name: 'Ad',
        component: Ad,
      },
      {
        path: '/ad/create',
        name: 'AdCreate',
        component: AdCreate,
      },
      {
        path: '/ad/:id/edit',
        name: 'AdEdit',
        component: AdEdit,
        props: true
      },
      {
        path: '/',
        name: 'UserDetail',
        component: UserDetail,
      },
      {
        path: '/user_detail/create',
        name: 'UserDetailCreate',
        component: UserDetailCreate,
      },
      {
        path: '/user_detail/:id/edit',
        name: 'UserDetailEdit',
        component: UserDetailEdit,
        props: true
      },
      {
        path: '/banner',
        name: 'Banner',
        component: () => {
          return import ('../components/admin/banner/Banner');
        },
      },
      {
        path: '/banner/create',
        name: 'BannerCreate',
        component: BannerCreate,
      },
      {
        path: '/banner/:id/edit',
        name: 'BannerEdit',
        component: BannerEdit,
        props: true
      },
      {
        path: '/articles',
        name: 'Articles',
        component: () => {
          return import ('../components/admin/articles/Articles');
        },
      },
      {
        path: '/articles/create',
        name: 'ArticlesCreate',
        component: ArticlesCreate,
      },
      {
        path: '/articles/:id/edit',
        name: 'ArticlesEdit',
        component: ArticlesEdit,
        props: true
      },
      {
        path: '/setting',
        name: 'Setting',
        component: () => {
          return import ('../components/admin/setting/Setting');
        },
      },
      {
        path: '/setting/create',
        name: 'SettingCreate',
        component: SettingCreate,
      },
      {
        path: '/setting/:id/edit',
        name: 'SettingEdit',
        component: SettingEdit,
        props: true
      },
      {
        path: '/dy_log',
        name: 'DyLog',
        component: () => {
          return import ('../components/admin/dy_log/DyLog');
        },
      },
      {
        path: '/dy_log/create',
        name: 'DyLogCreate',
        component: DyLogCreate,
      },
      {
        path: '/dy_log/:id/edit',
        name: 'DyLogEdit',
        component: DyLogEdit,
        props: true
      },
      {
        path: '/admin',
        name: 'Admin',
        component: () => {
          return import ('../components/admin/admin/Admin');
        },
      },
      {
        path: '/admin/create',
        name: 'AdminCreate',
        component: AdminCreate,
      },
      {
        path: '/admin/:id/edit',
        name: 'AdminEdit',
        component: AdminEdit,
        props: true
      },
      {
        path: '/roles',
        name: 'Roles',
        component: () => {
          return import ('../components/admin/roles/Roles');
        },
      },
      {
        path: '/roles/create',
        name: 'RolesCreate',
        component: RolesCreate,
      },
      {
        path: '/roles/:id/edit',
        name: 'RolesEdit',
        component: RolesEdit,
        props: true
      },
      {
        path: '/permissions',
        name: 'Permissions',
        component: () => {
          return import ('../components/admin/permissions/Permissions');
        },
      },
      {
        path: '/permissions/create',
        name: 'PermissionsCreate',
        component: PermissionsCreate,
      },
      {
        path: '/permissions/:id/edit',
        name: 'PermissionsEdit',
        component: PermissionsEdit,
        props: true
      },

      {
        path: '/zip_job',
        name: 'ZipJob',
        component: () => {
          return import ('../components/admin/zip_job/ZipJob');
        },
      },
      {
        path: '/zip_job/create',
        name: 'ZipJobCreate',
        component: ZipJobCreate,
      },
      {
        path: '/zip_job/:id/edit',
        name: 'ZipJobEdit',
        component: ZipJobEdit,
        props: true
      },
      {
        path: '/zip_clash',
        name: 'ZipClash',
        component: () => {
          return import ('../components/admin/zip_clash/ZipClash');
        },
        props: (route) => ({zipJobId: route.query.zipJobId})
      },
      {
        path: '/zip_clash/create',
        name: 'ZipClashCreate',
        component: ZipClashCreate,
      },
      {
        path: '/zip_clash/:id/edit',
        name: 'ZipClashEdit',
        component: ZipClashEdit,
        props: true
      },
      //router hook
      {
        path: '/about/:id',
        name: 'About',
        component: About,
        props: true
      },
    ]
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/admin.js